import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';
import AreaSplineChartWithHeader from './../../component/areaSplineChartWithHeader';
import Utils from './../../component/utils/utils';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedInterval: 60,
    }

    componentDidMount () {
        Service.event.onFetchRevenueSeriesChartData.add((data) => {
            this.setState({
                renderChart : true,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1,
                histogramChartSeriesDataList2: data.chartData.seriesDataList2,
                histogramChartSeriesDataList3: data.chartData.seriesDataList3,
            });
        });

        Service.fetchRevenueSeriesByDay(this.state.selectedInterval);
    }

    componentWillUnmount() {

    }

    constructor() {
        super();
        // setting default attribute values
        this.intervalOptions = Utils.intervalOptions;
    }

    selectElementChange = (event) => {
        this.setState({ selectedInterval: event.target.value});
        Service.fetchRevenueSeriesByDay(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchRevenueSeriesByDay(this.state.selectedInterval);
    };

    render() {
        return (
            <div className="graph-width">
                { this.state.renderChart ? <AreaSplineChartWithHeader
                    chartTitle = {"Total/New/Repeat Revenue For The Last " + this.state.selectedInterval + " days"}
                    histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                    histogramChartSeriesDataList = {
                        [{
                            name: 'Total Revenue',
                            data: this.state.histogramChartSeriesDataList1
                        },{
                            name: 'New Revenue',
                            data: this.state.histogramChartSeriesDataList2
                        },{
                            name: 'Repeat Revenue',
                            data: this.state.histogramChartSeriesDataList3
                        }]
                    }
                    selectElementChange = {this.selectElementChange}
                    searchButtonAction = {this.searchButtonAction}
                    selectDropdownValues = {this.intervalOptions}
                    yAxisTitle = "Total/New/Repeat Revenue"
                    headerIconClass = "fa fa-credit-card"
                    dolarSignFormat = "true"
                /> : '' }
            </div>
        );
    }
}

export default ChartView;